import { List, Map } from 'immutable'
import { browserHistory } from 'react-router'

import wopi360Service from '../services/wopi360'

import { NO_MORE_WOPI_CREDITS } from './questionnaire-admin'

const SEARCH_TARGETS = 'admin/wopi360-targets/SEARCH'
const FILTER_TARGETS = 'admin/wopi360-targets/FILTER'
const PAGINATE_TARGETS = 'admin/wopi360-targets/PAGINATE'

const CREATE = 'admin/wopi360-targets/CREATE'
export const CREATE_SUCCESS = 'admin/wopi360-targets/CREATE_SUCCESS'
const CREATE_FAILURE = 'admin/wopi360-targets/CREATE_FAIL'

const EDIT = 'admin/wopi360-targets/EDIT'
const EDIT_SUCCESS = 'admin/wopi360-targets/EDIT_SUCCESS'

const DELETE_TARGET = 'admin/wopi360-targets/DELETE_TARGET'
export const DELETE_TARGET_SUCCESS = 'admin/wopi360-targets/DELETE_TARGET_SUCCESS'
const DELETE_TARGET_FAILURE = 'admin/wopi360-targets/DELETE_TARGET_FAILURE'

const CLOSE_TARGET = 'admin/wopi360-targets/CLOSE_TARGET'
const CLOSE_TARGET_SUCCESS = 'admin/wopi360-targets/CLOSE_TARGET_SUCCESS'
const CLOSE_TARGET_FAILURE = 'admin/wopi360-targets/CLOSE_TARGET_FAILURE'
const CLOSE_TARGET_CLEAR = 'admin/wopi360-targets/CLOSE_TARGET_CLEAR'

const defaultState = Map({
  wopi360Targets: null,
  searchFilters: { status: 'closed' },
  pagination: null,
  closedWopi360Target: null,
  deletedWopi360Targets: List()
})

export default function(state = defaultState, action = undefined) {
  switch (action.type) {
    case FILTER_TARGETS:
      return state.update('searchFilters', filters => action.payload)

    case SEARCH_TARGETS:
      return state.update('wopi360Targets', targets => action.payload)

    case PAGINATE_TARGETS:
      return state.update('pagination', pagination => action.payload)

    case CLOSE_TARGET_SUCCESS:
      return state.update('closedWopi360Target', closed => action.payload.uuid)

    case CLOSE_TARGET_CLEAR:
      return state.update('closedWopi360Target', closed => null)

    case DELETE_TARGET_SUCCESS:
      return state.update('deletedWopi360Targets', deleted => deleted.push(action.payload.uuid))

    default:
      return state
  }
}

export function searchWopi360Targets({ organisationId, unitUuid, keyword, filters, page }) {
  return function d(dispatch) {
    dispatch({ type: FILTER_TARGETS, payload: filters })
    dispatch({ type: SEARCH_TARGETS, payload: null })
    dispatch({ type: PAGINATE_TARGETS, payload: null })

    return wopi360Service
      .searchWopi360Targets({
        organisationId,
        unitUuid,
        keyword,
        filters,
        page: page || 1
      })
      .then(response => {
        dispatch({ type: SEARCH_TARGETS, payload: List(response.data.results) })
        dispatch({ type: PAGINATE_TARGETS, payload: response.data.pagination })
      })
  }
}

export function createWopi360Target(
  organisationId,
  givenName,
  familyName,
  email,
  organisationName,
  role,
  deadlineAt,
  language,
  isManager,
  canInvite,
  message,
  unitUuids
) {
  return dispatch => {
    dispatch({ type: CREATE })

    return wopi360Service
      .createWopi360Target(
        organisationId,
        givenName,
        familyName,
        email,
        organisationName,
        role,
        deadlineAt,
        language,
        isManager,
        canInvite,
        message,
        unitUuids
      )
      .then(response => {
        const data = response.data

        dispatch({ type: CREATE_SUCCESS, payload: data })

        browserHistory.push(`/target/${data.targetUuid}/details`)
      })
      .catch(error => {
        dispatch({ type: CREATE_FAILURE })

        if (error && error.response && error.response.status === 409) {
          dispatch({ type: NO_MORE_WOPI_CREDITS })
        }
      })
  }
}

export function editWopi360Target(
  organisationId,
  uuid,
  givenName,
  familyName,
  email,
  organisationName,
  role,
  deadlineAt,
  language,
  unitUuids
) {
  return dispatch => {
    dispatch({ type: EDIT })

    return wopi360Service
      .editWopi360Target(
        organisationId,
        uuid,
        givenName,
        familyName,
        email,
        organisationName,
        role,
        deadlineAt,
        language,
        unitUuids
      )
      .then(response => {
        dispatch({ type: EDIT_SUCCESS })

        browserHistory.push(`/target/${uuid}/details`)
      })
  }
}

export function closeWopi360Target(uuid) {
  return dispatch => {
    dispatch({ type: CLOSE_TARGET })

    return wopi360Service
      .closeWopi360Target(uuid)
      .then(response => {
        dispatch({ type: CLOSE_TARGET_SUCCESS, payload: { uuid } })

        browserHistory.push('/wopi360')

        setTimeout(() => dispatch({ type: CLOSE_TARGET_CLEAR }), 10000)
      })
      .catch(e => dispatch({ type: CLOSE_TARGET_FAILURE, payload: e }))
  }
}

export function deleteWopi360Target(organisationId, uuid) {
  return dispatch => {
    dispatch({ type: DELETE_TARGET })

    return wopi360Service
      .deleteWopi360Target(organisationId, uuid)
      .then(response => {
        const { data: { creditsWopi360 } } = response
        dispatch({ type: DELETE_TARGET_SUCCESS, payload: { uuid, creditsWopi360 } })
      })
      .catch(e => dispatch({ type: DELETE_TARGET_FAILURE, payload: e }))
  }
}



// WEBPACK FOOTER //
// ./src/ducks/wopi360-targets-admin.js